import { Content } from '../../types';

export const bangkokMarketsContent: Content = {
  title: 'שווקים בבנגקוק - חוויית קניות שאין לה תחליף',
  imageUrl: '/images/thailand/bangkok-markets/bangkok-markets-wide.jpeg',
  introduction: `בנגקוק הינה גן עדן לחובבי השווקים. השווקים הינם חלק בלתי נפרד מחיי היום-יום ומהתרבות המקומית, מציעים שפע של חוויות קולינריות, אופנה במחירים זולים, מזכרות ייחודיות, אווירה תוססת וניחוחות בלתי נשכחים. השווקים הרבים בעיר מספקים חוויית קניות יוצאת דופן, עם מבחר אינסופי של מוצרים ומפגש בלתי אמצעי עם המקומיים. להלן מדריך אודות כמה מהשווקים המומלצים ביותר שלא כדאי לפספס.`,
  sections: [
    {
      title: 'השווקים המומלצים בבנגקוק',
      type: 'sub-headers',
      description: 'להלן רשימת השווקים המובילים בבנגקוק שכדאי לבקר בהם:',
      content: [
        {
          subtitle: 'שוק סוף השבוע צ׳אטוצ׳אק (Chatuchak Market)',
          text: "שוק צ'אטוצ'אק הוא הגדול ביותר בתאילנד ואחד מהשווקים הגדולים בעולם, עם יותר מ-15,000 דוכנים! השוק מחולק למקטעים ולסמטאות מסודרות, כך שניתן לנווט בו ועם זאת, הטיפ הכי חשוב הינו כי במידה וראיתם בדוכנים הפנימיים מוצר שמצא חן בעיניכם, קנו אותו, אחרת הסיכוי שתצליחו למצוא את אותו דוכן בשנית אינו גדול. תמצאו כאן הכול: ביגוד, הנעלה, תכשיטים, תיקים, כלי בית, חפצי נוי, מזכרות, צמחים, חיות מחמד ואפילו מסאז'ים. השוק פעיל רק בסופי השבוע (שבת וראשון) בין השעות 08:00-19:00. מומלץ להגיע מוקדם בבוקר כדי להימנע מהעומס וליהנות משופינג נוח ונעים. עם זאת, בשעות אחר הצהריים המקום מתמלא במקומיים, מה שמעניק חוויה תרבותית אותנטית.",
        },
        {
          subtitle: '',
          text: 'בשעה 19:00, הופך חלק מהמתחם לשוק אוכל אותנטי וטעים להפליא! הרכבות העילית והתחתית מגיעות למקום.',
        },
        {
          subtitle: 'צ׳יינה טאון - Yaowarat Road',
          text: "במהלך היום, רחוב Sampheng משמש כשוק עצום למוצרים מגוונים, כולל תכשיטים ואקססוריז, ביגוד, הנעלה, צעצועים, מוצרי אלקטרוניקה, כלי בית, כלי עבודה, מכשירי כתיבה, חומרי גלם לייצור תכשיטים, שעונים ועוד ועוד. בשעות הלילה, האזור התוסס של צ'יינה טאון, Yaowarat Road, הופך לשוק אוכל ססגוני, שם ניתן למצוא מנות רחוב אותנטיות ואף כאלו המומלצות על ידי מישלן, לצד פירות ים טריים, קינוחים סיניים מסורתיים ואוכל רחוב ייחודי.מומלץ מאוד לשוטט בין הסמטאות הצרות, בשעות היום והלילה ולגלות הן הפתעות קולינריות בלילה והן פריטים ייחודיים במהלך היום.",
        },
        {
          subtitle: '',
          text: 'הרכבת התחתית וסירות הנהר מגיעות למקום.',
        },
        {
          subtitle: 'שוק פראטונם (Pratunam Market)',
          text: 'שוק פראטונם ממוקם בלב אזור הקניות המרכזי של בנגקוק, בין קניון Platinum Fashion Mall לבין Baiyoke Sky Hotel. זהו אחד השווקים הזולים ביותר לביגוד ואקססוריז, עם מגוון עצום של פריטים מקומיים וחיקויים במחירים נמוכים במיוחד. השוק פתוח משעות הבוקר המוקדמות ועד שעות אחר הצהריים, אם כי חלקים ממנו ממשיכים לפעול גם לאחר מכן. אם אתם מחפשים בגדים אופנתיים במחירים סופר משתלמים, זהו המקום בשבילכם.',
        },
        {
          subtitle: '',
          text: 'הרכבות העילית והתחתית וסירות התעלה מגיעות לאזור השוק.',
        },
        {
          subtitle: 'שוק הפרחים Pak Khlong Talad',
          text: 'זהו שוק הפרחים הסיטונאי הגדול ביותר בבנגקוק, שמהווה חגיגה של צבעים וריחות. מומלץ להגיע אליו בשעות הקטנות של הלילה, כאשר הסחורה מגיעה מהחקלאים ומועברת אל הדוכנים, או בשעות הבוקר המוקדמות כדי ליהנות מהמראות והניחוחות הטריים. תמצאו כאן סוגים רבים של פרחים, סידורי פרחים מסורתיים וגם צמחי נוי מרהיבים.',
        },
        {
          subtitle: '',
          text: 'הרכבת התחתית וסירות הנהר מגיעות למקום.',
        },
        {
          subtitle: 'שוק הלילה Jodd Fairs',
          text: "אחד מהשווקים החדשים והאופנתיים ביותר בבנגקוק, הממוקם בסמוך לקניון Central Rama 9. השוק מציע דוכני ביגוד, הנעלה, תכשיטים, מזכרות ומתחמי אוכל מגוונים, כולל מנות רחוב מקומיות ומנות פיוז'ן טרנדיות. זהו מקום מושלם לבלות בו את שעות הערב, לשבת על כוס בירה וליהנות ממוזיקה חיה.",
        },
        {
          subtitle: '',
          text: 'הרכבת התחתית מגיעה למקום.',
        },
        {
          subtitle: 'שוק הלילה Asiatique The Riverfront',
          text: "שוק מודרני השוכן לצד נהר הצ'או פראיה ומציע שילוב של קניות, אוכל ובילוי. כאן תמצאו חנויות ודוכנים עם בגדים, מזכרות, אומנות מקומית ותכשיטים לצד מסעדות וברים עם נוף מרהיב לנהר. השוק פתוח משעות אחר הצהריים ועד שעות הלילה המאוחרות וכולל גם מופעים שונים כמו תיאטרון בובות תאילנדי ומופעי קברט.",
        },
        {
          subtitle: '',
          text: 'סירות הנהר מגיעות למקום.',
        },
        {
          subtitle:
            'שוק הרכבת (Train Night Market Srinakarin/ Talad Rot Fai - Train Market)',
          text: "שוק רטרו פופולרי במיוחד בקרב צעירים, שמציע פריטים וינטג', רהיטים משופצים, בגדים בסגנון נוסטלגי, צעצועים ישנים ורכבי אספנות. לצד זאת, תמצאו כאן מתחם אוכל מרהיב, פאבים קטנים ומוזיקה חיה. זהו שוק המשלב בין מסורת למודרניות, ומעניק חוויית קניות מיוחדת. השוק פתוח בכל ימות השבוע.",
        },
        {
          subtitle: '',
          text: 'הקו הצהוב של הרכבת התחתית (קו מחבר) מגיע למקום.',
        },
        {
          subtitle: 'שוק הלילה One Ratchada',
          text: "שוק הלילה One Ratchada ממוקם במקום בו היה בעבר שוק הרכבת רוט פאי ברצ'דה. זהו שוק צבעוני ומודרני המציע שילוב של דוכני בגדים, אביזרים, מזכרות ומתחמי אוכל מגוונים. במקום ניתן למצוא מנות אוכל רחוב תאילנדי לצד מטבחים בינלאומיים, ברים עם אווירה תוססת ונקודות צילום מרהיבות עם תאורה מיוחדת. השוק פתוח מדי ערב ומהווה מוקד בילוי פופולרי לצעירים ולתיירים.",
        },
        {
          subtitle: '',
          text: 'הרכבת התחתית מגיעה למקום.',
        },
        {
          subtitle: 'רחוב הקאוסאן',
          text: "רחוב הקאוסאן הפופולרי בקרב מטיילים משמש במהלך היום כרחוב מסחרי הכולל, בין היתר, שוק דוכנים עם ביגוד, תיקים, מזכרות ואקססוריז, ובלילה הופך למרכז בילוי מרכזי ותוסס ביותר עם ברים, מועדונים ודוכני אוכל. הרחוב המקביל אליו, Rambutri Rd, מציע אווירה מעט רגועה יותר אך לא פחות מהנה, ברים, פאבים, מסעדות, דוכנים שונים ומסאג'ים.",
        },
        {
          subtitle: '',
          text: 'הרכבת התחתית וסירות התעלה מגיעות לאזור.',
        },
      ],
    },
    {
      title: "שוק האוכל של צ'יינה טאון",
      content: '',
      type: 'image',
      imageUrl:
        '/images/thailand/bangkok-markets/bangkok-markets-article-1.jpeg',
    },
    {
      title: 'בשורה התחתונה',
      content: `בנגקוק מציעה מגוון עצום של שווקים, כל אחד עם האופי הייחודי שלו. בין אם אתם מחפשים אופנה זולה, אוכל רחוב אותנטי, פרחים מרהיבים או מזכרות ייחודיות - העיר הזו תספק לכם חוויית קניות בלתי נשכחת. מומלץ לשלב כמה מהשווקים ברשימה בביקור הבא שלכם וליהנות מהאווירה התוססת של בנגקוק!`,
      type: 'text',
      isBold: true,
    },
  ],
};
